import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconPatient: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.6283 0.768402C12.6535 1.79294 12.6535 3.45403 11.6283 4.47857C10.6032 5.50311 8.94116 5.50311 7.91603 4.47857C6.8909 3.45403 6.8909 1.79294 7.91603 0.768402C8.94116 -0.256134 10.6032 -0.256134 11.6283 0.768402Z"
        fill="#1E2846"
      />
      <path
        d="M18.2566 5.99653H1.28781C0.588825 5.99653 0.0221863 6.56284 0.0221863 7.26143C0.0221863 7.96001 0.588825 8.52632 1.28781 8.52632H6.06344C6.38734 8.52632 6.76656 8.67108 6.98125 9.22904C7.23203 9.87695 7.10922 11.1283 6.95453 12.0975L6.75203 13.243C6.75279 13.249 6.75072 13.2551 6.7464 13.2594L5.12453 22.4795C5.00208 23.1763 5.46618 23.8409 6.16281 23.9665C6.85264 24.0884 7.51077 23.6284 7.63278 22.9389C7.63377 22.9334 7.63471 22.9278 7.63562 22.9222L8.7564 16.5134C8.7564 16.5134 9.11594 14.9913 9.77219 14.9913C10.4392 14.9913 10.7913 16.5134 10.7913 16.5134L11.912 22.9278C12.0249 23.6235 12.6806 24.0961 13.3767 23.9834C14.0729 23.8706 14.5457 23.2152 14.4329 22.5195C14.4306 22.5057 14.4282 22.4919 14.4255 22.4781L12.8031 13.258C12.8038 13.252 12.8019 13.2461 12.798 13.2416L12.595 12.0961C12.4403 11.1269 12.3175 9.87555 12.5683 9.22764C12.782 8.67109 13.1734 8.52493 13.472 8.52493H18.2566C18.9555 8.52493 19.5222 7.95861 19.5222 7.26003C19.5222 6.56145 18.9555 5.99514 18.2566 5.99514V5.99653Z"
        fill="#1E2846"
      />
    </svg>
  </IconStyled>
);

IconPatient.defaultProps = iconDefaultProps;
IconPatient.displayName = 'IconPatient';

export default IconPatient;
